import React from 'react';
import {Get, Post} from "../../components/request";
import ConditionsGenerales from "./conditionsGenerales";
import {toast} from "react-toastify";
import screens from "../../screens";
import DivTable from "../../components/divTable";
import MyToggle from "../../components/myToggle";
import {Alert, Button, Col, Fade, Form, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faTimes} from "@fortawesome/pro-solid-svg-icons";
import {withRouter} from "react-router-dom";
import ScreenComponent from "../../components/screenComponent";
import {getRoute} from "../../breadcrumb/utils";

class NouvelleCommande extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            ConGenLu: false,
            syllabi: [],
            supplements: [],
            commande: [],
            total: 0,
            selectAll: false,
            showSupplements: false,
        };
    }

    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get('/v1/extranet/student/hasOrderLast72Hours');

        if (body !== false) {
            toast.warn(<>Vous avez déjà passé une commande récemment. <br/>Vous en trouverez la confirmation dans votre
                boîte mail @student.ichec.be</>, {
                autoClose: false
            })
        }

        ({body} = await Get(`/v1/extranet/student/${screens.NouvelleCommande}`));

        this.setState({
            syllabi: body
        });

        ({body} = await Get(`/v1/extranet/student/${screens.NouvelleCommande}01`));

        this.setState({
            supplements: body
        })
    }

    async postCommande() {
        const body = this.state.syllabi.filter((item) => item.hasBeenModified);
        const lignes = body.filter((item) => item.LigneCommandeQuantite > 0);

        if (body.length === 0 || lignes.length <= 0) {
            return toast.warning("Au moins un support doit être sélectionné pour valider la commande.");
        }

        this.setState({
            showSupplements: false,
        });

        this.SaveCommande.disabled = true;
        this.SelectAll.disabled = true;
        this.AddSupplements.disabled = true;

        this.state.syllabi.forEach((item) => {
            item.ref.setState({disabled: true});
            delete item.ref;
            delete item.refSup;
        });

        let result = await Post(`/v1/extranet/student/commandeSyllabus`, lignes, "Le processus de sauvegarde peut durer quelques secondes. Vous serez redirigés sur la liste des commandes à la fin de l'opération.", {
            render: <><FontAwesomeIcon className="mr-2" icon={faCheck}/>La commande a correctement été envoyée. <br/>Vous
                en trouverez la confirmation dans votre boîte mail @student.ichec.be</>
        }, {
            render: <><FontAwesomeIcon className="mr-2" icon={faTimes}/>Impossible de valider la commande.</>
        });

        if (result) {
            this.props.history.push(getRoute(screens.Commandes));
        } else {
            await this.componentDidMount();
            this.SaveCommande.disabled = false;
            this.SelectAll.disabled = false;
            this.AddSupplements.disabled = false;
            this.state.syllabi.forEach((item) => {
                item.ref.setState({
                    disabled: false,
                    checked: false,
                });
            });
        }
    }

    updateCheckedSyllabi(elm, checked) {
        elm.ref.setState({
            checked: checked !== null ? checked : !elm.addToCommande
        }, () => {
            elm.hasBeenModified = true;
            elm.addToCommande = checked !== null ? checked : !elm.addToCommande;
            elm.LigneCommandeQuantite = elm.addToCommande ? 1 : 0;

            this.setState({
                syllabi: this.state.syllabi
            });

            this.calculateTotal();
        });
    }

    updateCheckedSupplements(elm, event) {

        elm.fromSupplement = true;

        if (!event.state.checked && this.state.syllabi.includes(elm)) {
            this.state.syllabi.splice(this.state.syllabi.indexOf(elm));
        } else {
            this.state.syllabi.push(elm);
        }
    }

    updateLigneCommandeQuantite(item, event) {
        item.LigneCommandeQuantite = parseInt(event.target.value);

        if (item.LigneCommandeQuantite <= 0) {
            return this.updateCheckedSyllabi(item, null);
        }

        this.setState({
            syllabi: this.state.syllabi
        });

        this.calculateTotal();
    }

    selectAll() {
        this.state.syllabi.forEach((item) => {
            this.updateCheckedSyllabi(item, !this.state.selectAll);
        });

        this.setState({
            selectAll: !this.state.selectAll,
            syllabi: this.state.syllabi
        });
    }

    calculateTotal() {
        let total = 0;
        this.state.syllabi.forEach((item) => {
            total += item.LigneCommandeQuantite * item.SupportCoursPrix;
        });

        this.setState({
            total: total
        });
    }

    showSupplementsAlert() {
        if (!this.state.showSupplements)
            toast.warn(
                <>
                    <div>
                        Les supports de cours proposés de base dans la liste sont ceux requis par votre programme annuel
                        de
                        cours. Si vous choisissez des supports non proposés dans la liste, vous reconnaissez le faire en
                        pleine connaissance de cause. En aucun cas le SIC ne pourra en être tenu pour responsable ;
                        aucun
                        remboursement ne sera octroyé pour un support de cours qui s’avèrerait ne pas être nécessaire.
                    </div>
                    <div className={"my-3 text-center"}>
                        <Button onClick={() => this.setState({showSupplements: true})} className="mr-2" size="lg">J'ai
                            compris, je
                            continue !</Button>
                    </div>
                </>
                , {autoClose: false});
    }

    addToCart() {
        this.setState({
            syllabi: this.state.syllabi,
            showSupplements: false,
        }, () => {
            this.state.syllabi.filter(f => f.fromSupplement).map(m => this.updateCheckedSyllabi(m, true))
        });
    }

    renderSyllabi() {
        return (
            <>
                <Alert variant={"info"}>
                    La mention « IDEM » à côté des titres signifie que l’ouvrage est identique à la version de l'année
                    dernière.<br/>
                    La mention « NEW » signale un ouvrage différent de l’édition de l'année dernière.<br/>
                    Aucun support de cours n’est obligatoire.
                </Alert>
                <DivTable columns={{
                    "Sélection": (item) => {
                        return (
                            <div className="p-1 d-flex justify-content-center align-items-center">
                                <MyToggle ref={(r) => item.ref = r}
                                          onChange={this.updateCheckedSyllabi.bind(this, item, null)}
                                />
                            </div>
                        );
                    },
                    "Type du support": "TypeSupportCours",
                    "Support": "SupportCoursLibelle",
                    "Code interne": "SupportCoursCodeInterne",
                    "Activité(s) d'Apprentissage liée(s)": "ActiviteApprentissageLiees",
                    "Prix unitaire": "SupportCoursPrix",
                    "Quantité": (item) => {
                        return (
                            <div className="p-1 d-flex justify-content-center align-items-center">
                                <Form.Control onChange={this.updateLigneCommandeQuantite.bind(this, item)}
                                              type="number" step="1" min="0"
                                              value={item.LigneCommandeQuantite}
                                              disabled={item.LigneCommandeQuantite === 0}/>
                            </div>
                        );
                    }
                }}
                          array={this.state.syllabi}
                />
                <Row className={"my-2"}>
                    <Col className={"my-3"} xs={12} md={6}>
                        <Button ref={(r) => this.SelectAll = r} className={"mb-3"} onClick={this.selectAll.bind(this)}
                                size="lg"
                                variant="outline-primary" block>Tout (dé)séléctionner</Button>
                        <Button ref={(r) => this.AddSupplements = r} className={"mt-3"}
                                onClick={this.showSupplementsAlert.bind(this)} size="lg"
                                variant="outline-info"
                                block>Ajouter un support non proposé dans la liste</Button>
                    </Col>
                    <Col className={"my-3 text-center"}>
                        <h3 className={"mb-3"} style={{"paddingTop": "1.25px"}}>
                            Montant total: {this.state.total.toFixed(2)} €
                        </h3>
                        <Button ref={(r) => this.SaveCommande = r} onClick={this.postCommande.bind(this)}
                                className={"mt-3"} size="lg" variant="success" block>Valider la commande</Button>

                    </Col>
                </Row>
            </>
        );
    }

    renderSupplements() {
        return (
            <>
                <Button onClick={this.addToCart.bind(this)} className="my-4" size="lg" variant="outline-dark" block>
                    Modifier le panier
                </Button>
                <DivTable columns={{
                    "Sélection": (item) => {
                        return (
                            <div className="p-1 d-flex justify-content-center align-items-center">
                                <MyToggle ref={(r) => item.refSup = r}
                                          onChange={this.updateCheckedSupplements.bind(this, item)}
                                />
                            </div>
                        );
                    },
                    "Type du support": "TypeSupportCours",
                    "Support": "SupportCoursLibelle",
                    "Code interne": "SupportCoursCodeInterne",
                    "Activité(s) d'Apprentissage liée(s)": "ActiviteApprentissageLiees",
                    "Prix unitaire": "SupportCoursPrix"
                }}
                          array={this.state.supplements}
                />
                <Button onClick={this.addToCart.bind(this)} className="my-4" size="lg" variant="outline-dark" block>
                    Modifier le panier
                </Button>
            </>
        );
    }

    render() {
        return (
            <>
                <section>
                    {this.state.ConGenLu
                        ? this.renderSyllabi()
                        : <ConditionsGenerales updateRead={() => this.setState({ConGenLu: true})}/>}
                </section>
                <section>
                    <Fade className={!this.state.showSupplements ? "collapse" : ""} in={this.state.showSupplements}>
                        <div>
                            {this.renderSupplements()}
                        </div>
                    </Fade>
                </section>
            </>
        );
    }
}

export default withRouter(NouvelleCommande);